import './index.css';
import React, { useState, useEffect, useRef } from 'react';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, addDoc, updateDoc, onSnapshot, deleteDoc, doc, writeBatch, getDocs, setDoc, enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBrRkkQpHJuDpQ5es1pGbxkuZhgzvCMcrU",
  authDomain: "mc5star.firebaseapp.com",
  projectId: "mc5star",
  storageBucket: "mc5star.firebasestorage.app",
  messagingSenderId: "159306173964",
  appId: "1:159306173964:web:dffce3813009822d566829",
  measurementId: "G-8Q117DJ5JL"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

enableIndexedDbPersistence(db).catch(err => {
  console.warn('Offline persistence failed:', err.code);
});

try { getAnalytics(app); } catch (error) { console.warn("Analytics blocked locally."); }

const MAP_GROUND = "https://firebasestorage.googleapis.com/v0/b/mc5star.firebasestorage.app/o/Ground%20Floor-Map.png?alt=media&token=8703b434-9ab8-4bc2-999d-4e5b69745f78";
const MAP_UPPER  = "https://firebasestorage.googleapis.com/v0/b/mc5star.firebasestorage.app/o/Upper%20Floor-Map.png?alt=media&token=bf1ff6c4-f31c-46d2-9098-75e72096222d";

const ROOM_MAP_DATA = {
  'Atrium 1':          { floor: 'Upper',  x: '52%', y: '50%', img: MAP_UPPER  },
  'Atrium 2':          { floor: 'Upper',  x: '52%', y: '50%', img: MAP_UPPER  },
  'Newbury 1':         { floor: 'Ground', x: '36%', y: '39%', img: MAP_GROUND },
  'Newbury 2':         { floor: 'Ground', x: '40%', y: '33%', img: MAP_GROUND },
  'County':            { floor: 'Ground', x: '62%', y: '50%', img: MAP_GROUND },
  'The Oceanic':       { floor: 'Ground', x: '80%', y: '75%', img: MAP_GROUND },
  'Connaught':         { floor: 'Upper',  x: '26%', y: '33%', img: MAP_UPPER  },
  'Royal':             { floor: 'Upper',  x: '52%', y: '23%', img: MAP_UPPER  },
  'Commonwealth':      { floor: 'Upper',  x: '60%', y: '78%', img: MAP_UPPER  },
  'Commonwealth East': { floor: 'Upper',  x: '70%', y: '78%', img: MAP_UPPER  },
  'Commonwealth West': { floor: 'Upper',  x: '45%', y: '78%', img: MAP_UPPER  },
  'R 38':              { floor: 'Upper',  x: '88%', y: '36%', img: MAP_UPPER  },
  'R38 Foyer':         { floor: 'Upper',  x: '75%', y: '42%', img: MAP_UPPER  },
};

const TIMETABLE_ROOM_ORDER = [
  'Atrium 1','Atrium 2','Commonwealth','Commonwealth East','Commonwealth West',
  'Connaught','County','Newbury 1','Newbury 2','Newbury Back','Royal','R 38','R38 Foyer','The Oceanic'
];

const TIMETABLE_EVENT_DATES = {
  '2026-01-09': 'Friday 9th January',
  '2026-01-10': 'Saturday 10th January',
  '2026-01-11': 'Sunday 11th January',
};

const DJ_DATA = {
  '2026-05-01': [
    { room: 'Atrium — Afternoon Social', genre: 'Afternoon Social', slots: [
      { time: '16:00 – 18:00', dj: 'Dennis Dale' },
      { time: '18:00 – 20:00', dj: 'Mauricio / Tuli' },
    ]},
    { room: 'Royal — Party Night', genre: 'Tropical · Cuban / Timba / Son', slots: [
      { time: '22:00 – 23:00', dj: 'Show Time' },
      { time: '23:00 – 00:00', dj: 'Ariel Rios Robert' },
      { time: '00:00 – 01:00', dj: 'Fadi K' },
      { time: '01:00 – 02:00', dj: 'Richard Fallon' },
      { time: '02:00 – 03:30', dj: 'Fadi K' },
      { time: '03:30 – 05:00', dj: 'Richard Fallon' },
    ]},
    { room: 'Commonwealth — Party Night', genre: 'Salsa Dura / Palladium / Fania · Mambo · Cha Cha Cha', slots: [
      { time: '22:00 – 22:30', dj: 'Mauricio Reyes' },
      { time: '23:00 – 00:00', dj: 'Showtime' },
      { time: '00:00 – 01:00', dj: 'Mauricio Reyes' },
      { time: '01:00 – 02:00', dj: 'Tuli' },
      { time: '02:00 – 03:00', dj: 'Julian "The Duke"' },
      { time: '03:00 – 04:00', dj: 'Julian Summers' },
      { time: '04:00 – 05:00', dj: 'Tuli' },
      { time: '05:00 – 06:00', dj: 'Julian "The Duke"' },
    ]},
    { room: 'Newbury 1 — Party Night', genre: 'Bachata', slots: [
      { time: '21:00 – 23:00', dj: 'Pierre Henry / Oreo Sensual' },
      { time: '23:00 – 00:30', dj: 'TBC' },
      { time: '00:30 – 02:30', dj: 'TBC' },
      { time: '02:30 – 04:00', dj: 'TBC' },
      { time: '04:00 – 05:30', dj: 'TBC' },
    ]},
    { room: 'Atrium — Party Night', genre: 'Salsa Romantica & Son — Chill Zone', slots: [
      { time: '21:00 – 22:00', dj: 'Alvin Black' },
      { time: '22:00 – 23:00', dj: 'Tuli' },
      { time: '23:30 – 01:00', dj: 'Julian Summers' },
      { time: '01:00 – 02:00', dj: 'Fadi K' },
      { time: '02:00 – 03:00', dj: 'Alvin Black' },
      { time: '03:00 – 04:30', dj: 'Mauricio Reyes' },
      { time: '04:30 – 06:00', dj: 'Julian Summers' },
    ]},
  ],
  '2026-05-02': [
    { room: 'Atrium — Afternoon Social', genre: 'Salsa', slots: [
      { time: '15:00 – 17:00', dj: 'Amanda (15:00) / Eddie Hunt (16:00)' },
      { time: '17:00 – 19:00', dj: 'Julian "The Duke" / Tuli' },
    ]},
    { room: 'Atrium — Party Night', genre: 'Salsa Romantica & Son — Chill Zone', slots: [
      { time: '21:00 – 22:00', dj: 'Amanda' },
      { time: '22:00 – 23:00', dj: 'Mauricio Reyes' },
      { time: '23:00 – 00:00', dj: 'Julian "The Duke"' },
      { time: '00:00 – 01:00', dj: 'Erick The Saint' },
      { time: '01:00 – 02:00', dj: 'Amanda' },
      { time: '02:00 – 03:00', dj: 'Tuli' },
      { time: '03:00 – 04:00', dj: 'Hector' },
      { time: '04:00 – 05:00', dj: 'Eddie Hunt' },
      { time: '05:00 – 06:00', dj: 'Julian Summers' },
    ]},
    { room: 'Commonwealth — Party Night', genre: 'Salsa Dura / Palladium / Fania · Mambo · Cha Cha Cha', slots: [
      { time: '22:00 – 23:00', dj: 'Hector' },
      { time: '23:00 – 00:00', dj: 'Rupert Boyle' },
      { time: '00:00 – 01:00', dj: 'Mauricio Reyes' },
      { time: '01:00 – 02:00', dj: 'Eddie Hunt' },
      { time: '02:00 – 03:00', dj: 'Erick "The Saint"' },
      { time: '03:00 – 04:00', dj: 'Julian Summers' },
      { time: '04:00 – 05:00', dj: 'Tuli' },
      { time: '05:00 – 06:00', dj: 'Julian "The Duke"' },
    ]},
    { room: 'Royal — Party Night', genre: 'Tropical · Cuban / Timba / Son', slots: [
      { time: '22:00 – 23:00', dj: 'Richard Fallon' },
      { time: '23:00 – 00:00', dj: 'Ariel Rios' },
      { time: '00:00 – 01:00', dj: 'Javier La Rosa' },
      { time: '01:00 – 02:00', dj: 'Ariel Rios' },
      { time: '02:00 – 03:00', dj: 'Richard Fallon' },
      { time: '03:00 – 04:00', dj: 'Javier La Rosa' },
      { time: '04:00 – 05:00', dj: 'Richard Fallon' },
      { time: '05:00 – 06:00', dj: 'Javier La Rosa' },
    ]},
    { room: 'Connaught-Belvedere — Party Night', genre: 'Bachata', slots: [
      { time: '23:00 – 00:00', dj: 'LLB Bachata DJs' },
      { time: '01:00 – 02:00', dj: 'Dennis Dale' },
      { time: '02:00 – 04:00', dj: 'Pierre Henry' },
      { time: '04:00 – 06:00', dj: 'Oreo Sensual' },
    ]},
    { room: 'Room 38 Edwardian — Party Night', genre: 'Kizomba / Afroluso', slots: [
      { time: '22:00 – 00:00', dj: 'DJ Mineiro' },
      { time: '00:00 – 02:00', dj: 'DJ Blade' },
      { time: '02:00 – 04:00', dj: 'DJ Mineiro' },
      { time: '04:00 – 06:00', dj: 'DJ Blade' },
    ]},
  ],
  '2026-05-03': [
    { room: 'Atrium — Afternoon Social', genre: 'Salsa', slots: [
      { time: '15:00 – 17:00', dj: 'Amanda (15:00) / Alvin Black (17:00)' },
      { time: '17:00 – 19:00', dj: 'Julian Summers (17:00) / Tuli (18:00)' },
    ]},
    { room: 'Royal — Party Night', genre: 'Tropical · Cuban / Timba / Son', slots: [
      { time: '22:00 – 00:00', dj: 'Ariel Rios Robert' },
      { time: '00:00 – 02:00', dj: 'Richard Fallon' },
      { time: '02:00 – 03:00', dj: 'Javier La Rosa' },
      { time: '03:00 – 04:00', dj: 'Richard Fallon' },
      { time: '04:00 – 05:00', dj: 'Javier La Rosa' },
      { time: '05:00 – 06:00', dj: 'Richard Fallon' },
    ]},
    { room: 'Atrium — Party Night', genre: 'Salsa Romantica & Son — Chill Zone', slots: [
      { time: '22:00 – 23:00', dj: 'Alvin Black' },
      { time: '23:00 – 00:00', dj: 'Amanda' },
      { time: '00:00 – 01:00', dj: 'Rupert' },
      { time: '01:00 – 02:00', dj: 'Hector' },
      { time: '02:00 – 03:00', dj: 'Mauricio Reyes' },
      { time: '03:00 – 04:00', dj: 'Julian "The Duke"' },
      { time: '04:00 – 05:00', dj: 'Tuli' },
      { time: '05:00 – 06:00', dj: 'Eddie Hunt' },
    ]},
    { room: 'Commonwealth — Party Night', genre: 'Salsa Dura / Palladium / Fania · Mambo · Cha Cha Cha', slots: [
      { time: '22:00 – 23:00', dj: 'Erick "The Saint"' },
      { time: '23:00 – 00:00', dj: 'Mauricio Reyes' },
      { time: '00:00 – 01:00', dj: '"Live Band"' },
      { time: '01:00 – 02:30', dj: 'El Chino y la Diferencia' },
      { time: '02:30 – 03:30', dj: 'Tuli' },
      { time: '03:30 – 04:30', dj: 'Julian Summers' },
      { time: '04:30 – 06:00', dj: 'Julian "The Duke"' },
    ]},
    { room: 'Connaught-Belvedere — Party Night', genre: 'Bachata', slots: [
      { time: '22:00 – 00:00', dj: 'Bachata DJs' },
      { time: '00:00 – 02:00', dj: 'Dennis Dale' },
      { time: '02:00 – 03:00', dj: 'Pierre Henry' },
      { time: '03:00 – 05:00', dj: 'Dennis Dale' },
    ]},
    { room: 'Room 38 Edwardian — Party Night', genre: 'Kizomba — Afroluso', slots: [
      { time: '22:00 – 00:00', dj: 'DJ Mineiro' },
      { time: '00:00 – 02:00', dj: 'DJ Blade' },
      { time: '02:00 – 04:00', dj: 'DJ Mineiro' },
      { time: '04:00 – 06:00', dj: 'DJ Blade' },
    ]},
  ],
};

const styleTag = document.createElement("style");
styleTag.innerHTML = `@keyframes border-glow { 0%   { box-shadow: inset 14px 0 0 0 currentColor; } 50%  { box-shadow: inset 14px 0 0 0 currentColor, 0 0 25px currentColor; filter: brightness(1.2); } 100% { box-shadow: inset 14px 0 0 0 currentColor; } } @keyframes map-pulse { 0%   { transform: translate(-50%,-50%) scale(1);   opacity: 1;   } 50%  { transform: translate(-50%,-50%) scale(1.6); opacity: 0.6; } 100% { transform: translate(-50%,-50%) scale(1);   opacity: 1;   } } @keyframes toast-in { 0% { opacity: 0; transform: translateX(-50%) translateY(16px); } 100% { opacity: 1; transform: translateX(-50%) translateY(0); } } .live-pulse { animation: border-glow 1.5s ease-in-out infinite !important; z-index: 40 !important; } .map-pin { position: absolute; width: 22px; height: 22px; background: #fbbf24; border: 3px solid white; border-radius: 50%; box-shadow: 0 0 15px rgba(0,0,0,0.4); animation: map-pulse 1.5s infinite; z-index: 110; } .overflow-x-auto { -webkit-overflow-scrolling: touch; overflow-x: auto; } .isolation-blur-container { transition: all 0.4s ease; } .is-blurred { filter: blur(12px); transform: scale(0.98); pointer-events: none; } .schedule-grid-container { display: grid; position: relative; background: #f1f5f9; gap: 1px; border: 1px solid #e2e8f0; border-radius: 1.5rem; min-width: 100%; -webkit-overflow-scrolling: touch; } .itinerary-list-container { display: flex; flex-direction: column; gap: 16px; padding: 12px; background: #f8fafc; } .grid-header { position: sticky; top: 0; z-index: 45; background: #f8fafc; font-weight: 900; text-transform: uppercase; font-size: 10px; display: flex; align-items: center; justify-content: center; padding: 12px; border-bottom: 2px solid #e2e8f0; color: #64748b; min-height: 55px; } .grid-time-label { position: sticky; left: 0; z-index: 40; background: #f8fafc; font-weight: 900; color: #94a3b8; display: flex; align-items: center; justify-content: center; border-right: 2px solid #e2e8f0; font-size: 12px; } .no-scrollbar::-webkit-scrollbar { display: none; } .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; } .sticky-filter-bar { position: sticky; top: 65px; z-index: 48; background: rgba(255,255,255,0.8); backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px); border-bottom: 1px solid rgba(0,0,0,0.05); } .card-premium { position: relative; overflow: hidden; border-radius: 2.5rem; box-shadow: inset 14px 0 0 0 currentColor; transition: all 0.2s ease; background: white; display: flex; flex-direction: column; height: 100%; } .star-pinned { outline: 4px solid #fbbf24; outline-offset: -4px; z-index: 30 !important; } .text-main { color: #0f172a !important; line-height: 1.2 !important; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; word-break: break-word; overflow-wrap: anywhere; } .text-sub { color: #64748b !important; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; } .keep-together { display: inline-block; } .venue-section h3 { font-size: 13px; font-weight: 900; text-transform: uppercase; letter-spacing: 0.08em; color: #C20032; margin: 20px 0 8px 0; } .venue-section ul { padding-left: 18px; margin: 0 0 8px 0; } .venue-section li { font-size: 13px; color: #334155; margin-bottom: 4px; line-height: 1.5; } .venue-section a { color: #C20032; text-decoration: none; } .venue-section a:hover { text-decoration: underline; } .venue-map-tab { cursor: pointer; padding: 8px 14px; border-radius: 10px; font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.06em; transition: all 0.15s; } .venue-map-tab.active { background: #0f172a; color: white; } .venue-map-tab:not(.active) { background: #f1f5f9; color: #64748b; } .share-toast { position: fixed; bottom: 32px; left: 50%; transform: translateX(-50%); background: #0f172a; color: white; border-radius: 12px; padding: 12px 24px; font-size: 13px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; z-index: 9999; box-shadow: 0 8px 32px rgba(0,0,0,0.3); white-space: nowrap; animation: toast-in 0.25s ease; } .tt-table { border-collapse: collapse; table-layout: auto; min-width: 100%; } .tt-th-time { background: #0f172a; color: white; font-size: 11px; font-weight: 800; width: 48px; min-width: 48px; text-align: center; padding: 6px 2px; text-transform: uppercase; letter-spacing: 0.06em; position: sticky; left: 0; z-index: 10; border-right: 2px solid #1e293b; border-bottom: 2px solid #C20032; } .tt-th-room { background: #C20032; color: white; font-size: 13px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.06em; text-align: center; padding: 6px 4px; border-left: 1px solid rgba(255,255,255,0.15); border-bottom: 2px solid #0f172a; min-width: 150px; line-height: 1.1; } .tt-td-time { background: #0f172a; color: white; font-size: 13px; font-weight: 700; text-align: center; vertical-align: top; padding-top: 6px; letter-spacing: 0.04em; border-right: 2px solid #1e293b; border-bottom: 1px solid #1e293b; white-space: nowrap; position: sticky; left: 0; z-index: 5; } .tt-td-cell { vertical-align: top; padding: 3px; border-left: 1px solid #e2e8f0; border-bottom: 1px solid #e2e8f0; background: #fafafa; min-width: 150px; } .tt-td-cell.alt { background: #f4f7fb; } .tt-card { height: 100%; border-radius: 6px; padding: 5px 7px; background: white; border-left: 7px solid #94a3b8; display: flex; flex-direction: column; justify-content: space-between; overflow: hidden; min-height: 110px; } .tt-card.closed { background: #f8fafc; border-left: 7px solid #e2e8f0; } .tt-artiste { font-size: 14px; font-weight: 800; color: #0f172a; line-height: 1.0; text-transform: uppercase; letter-spacing: 0.02em; } .tt-title { font-size: 11px; font-weight: 600; color: #334155; line-height: 1.2; margin-top: 2px; } .tt-bottom { display: flex; align-items: center; justify-content: space-between; margin-top: 4px; flex-shrink: 0; } .tt-time { font-size: 11px; font-weight: 700; color: #64748b; letter-spacing: 0.04em; } .tt-level { font-size: 9px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.06em; padding: 2px 6px; border-radius: 3px; color: white; } .tt-closed-text { color: #94a3b8; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.1em; margin: auto 0; } @media print { @page { size: landscape; margin: 10mm; } body { background: white !important; } .no-print, header, footer, .sticky-filter-bar, button, .admin-section, .no-scrollbar::-webkit-scrollbar { display: none !important; } .card-premium { box-shadow: none !important; border: 1px solid #ccc !important; border-left: 10pt solid currentColor !important; border-radius: 0 !important; break-inside: avoid !important; } .isolation-blur-container { filter: none !important; transform: none !important; } }`;
document.head.appendChild(styleTag);

const EVENT_COLORS = {
  'Beginners': 'color-orange-500', 'Beginners/Impr': 'color-orange-500',
  'Improvers': 'color-yellow-400', 'Improvers/Int': 'color-yellow-400',
  'Intermediate': 'color-blue-500', 'Advanced': 'color-red-500',
  'Int/Adv': 'color-green-500', 'Progressive': 'color-yellow-600',
  'Seminar': 'color-slate-500', 'All Levels': 'color-purple-500',
  'Social': 'color-cyan-500', 'Showtime': 'color-fuchsia-500',
  'Star Gate': 'color-gold-500', 'Closed': 'color-slate-inactive',
};

const COLOR_MAP = {
  'color-orange-500': '#f97316', 'color-yellow-400': '#fde047',
  'color-blue-500':   '#3b82f6', 'color-red-500':    '#f43f5e',
  'color-green-500':  '#22c55e', 'color-yellow-600': '#ca8a04',
  'color-slate-500':  '#64748b', 'color-purple-500': '#a855f7',
  'color-cyan-500':   '#06b6d4', 'color-fuchsia-500':'#d946ef',
  'color-gold-500':   '#f59e0b', 'color-slate-inactive': '#94A3B8',
  'color-slate-200':  '#e2e8f0',
};

const CAT_COLOR = {
  'Beginners':'#f97316','Beginners/Impr':'#f97316',
  'Improvers':'#eab308','Improvers/Int':'#eab308',
  'Intermediate':'#3b82f6','Advanced':'#f43f5e',
  'Int/Adv':'#22c55e','Progressive':'#ca8a04',
  'Seminar':'#94a3b8','All Levels':'#a855f7',
  'Social':'#06b6d4','Showtime':'#d946ef',
  'Star Gate':'#f59e0b','Closed':'#e2e8f0',
};

function hexToTint(hex, opacity) {
  const r = parseInt(hex.slice(1,3),16), g = parseInt(hex.slice(3,5),16), b = parseInt(hex.slice(5,7),16);
  return `rgba(${r},${g},${b},${opacity})`;
}

const PHOTO_MAP = {
  'Gabriel Delgado \u201cEl Chino\u201d': 'https://5starcongress.com/wp-content/uploads/2025/02/Gabriel-El-Chino-SQ.jpg',
  'Jose Antonio Molina': 'https://5starcongress.com/wp-content/uploads/2026/04/Jose-Antonio-Molina.png',
  'Jorge Luis & Indira': 'https://5starcongress.com/wp-content/uploads/2024/04/SQ-Jorge-Luis-Indira-3.png',
  'Delia & Raul': 'https://5starcongress.com/wp-content/uploads/2026/03/Delia-Raul-SQ.png',
  'Franklin Diaz': 'https://5starcongress.com/wp-content/uploads/2026/04/Franklin-Diaz-2.png',
  'Adolfo Indacochea': 'https://5starcongress.com/wp-content/uploads/2021/04/Adolfo-White2-scaled.jpg',
  'Adolfo & Tania': 'https://5starcongress.com/wp-content/uploads/2026/04/Adolfo-Tania.png',
  'Tania Cannarsa': 'https://5starcongress.com/wp-content/uploads/2025/03/Tania.png',
  'Angelo Rito': 'https://5starcongress.com/wp-content/uploads/2025/02/Angelo-Rito.png',
  'Fuquan & Candace': 'https://5starcongress.com/wp-content/uploads/2026/02/Fuquan-Candace-Fuego-Y-Hielo-2-SQ-scaled.png',
  'Leon Rose & Anna Villa': 'https://5starcongress.com/wp-content/uploads/2026/04/Leon-Anna.png',
  'Luanda Pau': 'https://5starcongress.com/wp-content/uploads/2026/04/Luanda_.png',
  'Ariel Rios Robert': 'https://5starcongress.com/wp-content/uploads/2026/03/Ariel-2-SQ.png',
  'Tomasa': 'https://5starcongress.com/wp-content/uploads/2025/01/La-Negra-1.jpeg',
  'Marchant & Davina': 'https://5starcongress.com/wp-content/uploads/2025/02/Marchant-Davina.png',
  'Shelley & Gil': 'https://5starcongress.com/wp-content/uploads/2021/10/Shelley-Gill.jpg',
  'Sasha Phillips': 'https://5starcongress.com/wp-content/uploads/2026/04/Sasha-Phillips.png',
  'Santee Hernandez': 'https://5starcongress.com/wp-content/uploads/2025/02/Santee.png',
  'Lewis & Katrin': 'https://5starcongress.com/wp-content/uploads/2026/02/Lewis-Katrin.png',
  'Kat & Eddie': 'https://5starcongress.com/wp-content/uploads/2026/03/Kat-Eddie-sq.png',
  'Elaine Greenwood': 'https://5starcongress.com/wp-content/uploads/2026/04/Elaine-Head-Shot.jpg',
  'Ewajo Dance Co': 'https://5starcongress.com/wp-content/uploads/2026/03/John-Gabriel-Ewajo-SQ-scaled.png',
  'Cao An & Yimini': 'https://5starcongress.com/wp-content/uploads/2026/02/C-Y-SQ.png',
  'Roberto Tambellini & Emma Marston': 'https://5starcongress.com/wp-content/uploads/2026/03/Roberto-Tambellini-Emma-Marston_.png',
  'Neil & Aimee': 'https://5starcongress.com/wp-content/uploads/2026/04/Neil-Aimee-sq.png',
  'Rohan Brown': 'https://5starcongress.com/wp-content/uploads/2022/03/Rohan.jpeg',
  'Julian The Duke': 'https://5starcongress.com/wp-content/uploads/2021/10/Julian-The-Duke-scaled.jpg',
  'Tuli': 'https://5starcongress.com/wp-content/uploads/2022/01/1-DJ-Tuli.jpg',
  'Julian Summers': 'https://5starcongress.com/wp-content/uploads/2022/01/Julian-Scotland-SQ.jpg',
  'Javier La Rosa': 'https://5starcongress.com/wp-content/uploads/2024/04/Javier-2.jpeg',
  'Erick The Saint': 'https://5starcongress.com/wp-content/uploads/2021/10/DJ-Eric-The-Saint-scaled.jpg',
  'Mauricio Reyes': 'https://5starcongress.com/wp-content/uploads/2021/10/Mauricio-Reyes.png',
  'Amanda Hallam': 'https://5starcongress.com/wp-content/uploads/2022/03/amanda.jpeg',
  'Rupert Boyle': 'https://5starcongress.com/wp-content/uploads/2022/01/Rupert-Boyle-Sq.jpg',
  'Eddie Hunt': 'https://5starcongress.com/wp-content/uploads/2026/03/Eddie-Hunt-SQ.png',
  'DJ Hector': 'https://5starcongress.com/wp-content/uploads/2026/03/Hector-2.jpeg',
  'DJ Alvin Black': 'https://5starcongress.com/wp-content/uploads/2026/04/DJ-Alvin-Black.png',
  'Anna Miller': 'https://5starcongress.com/wp-content/uploads/2023/03/Anna-Miller.jpg',
  'Darryl BG': 'https://5starcongress.com/wp-content/uploads/2022/03/darryl.jpeg',
  'Steve StarMambo': 'https://5starcongress.com/wp-content/uploads/2022/03/Steve-2.jpeg',
  'Iron Mambo': 'https://5starcongress.com/wp-content/uploads/2025/02/Iron-Mambo-1.png',
  'Juanjo & Maria': 'https://5starcongress.com/wp-content/uploads/2026/03/Juanjo-Maria-SQ-scaled.png',
  'Pierre Henry': 'https://5starcongress.com/wp-content/uploads/2022/03/Pierre-2.jpg',
  'Adem & Aitana': 'https://5starcongress.com/wp-content/uploads/2026/04/Adem-Aitana.png',
  'Dennis Dale': 'https://5starcongress.com/wp-content/uploads/2022/03/Dennis.jpeg',
};

const ARTIST_LIBRARY = [
  "Gabriel Delgado \u201cEl Chino\u201d","Jose Antonio Molina","Adolfo Indacochea",
  "Angelo Rito","Delia & Raul","Fuquan & Candace","Ariel Rios Robert",
  "Franklin Diaz","Jorge Luis & Indira","Marchant & Davina","Lewis & Katrin",
  "Cao An & Yimini","Sasha Phillips","Leon Rose & Anna Villa","Luanda Pau",
  "Tania Cannarsa","Tomasa","Adolfo & Tania","Rohan Brown","Julian The Duke",
  "Javier La Rosa","Julian Summers","Tuli","Amanda Hallam","Rupert Boyle",
  "Erick The Saint","Mauricio Reyes","Steve StarMambo","Iron Mambo","Darryl BG",
  "Anna Miller","Kat & Eddie","Juanjo & Maria","Adem & Aitana","Ewajo Dance Co",
  "Neil & Aimee","Elaine Greenwood","Shelley & Gil","Pierre Henry","Dennis Dale",
  "Roberto Tambellini & Emma Marston","Santee Hernandez","DJ Hector","DJ Alvin Black","Eddie Hunt"
];

const ROOM_LIST = ['Atrium 1','Atrium 2','Commonwealth','Connaught','County','Newbury 1','Newbury 2','Newbury Back','Royal','R 38','R38 Foyer'];

const EVENTBRITE_TOKEN = 'W5QDF2ABXNH7OAGLHB7U';
const EVENTBRITE_ORGANISER = '3023432912';

// ── SHARED NAV HEADER ────────────────────────────────────────────────────────
function SharedHeader({ activePage, onSchedule, onVenue, onHelp, onShare, onPoster, onTimetable }) {
  return (
    <header className="max-w-full mx-auto mb-2 bg-white px-4 pt-4 pb-3 md:px-6 md:pt-5 md:pb-4 rounded-2xl shadow-sm border border-slate-200 sticky top-0 z-50">
      <div className="flex justify-between items-center mb-1">
        <h1 className="text-2xl md:text-3xl font-black tracking-tighter uppercase leading-none text-slate-900">5Star Congress</h1>
      </div>
      <p className="text-[9px] font-bold text-red-600 uppercase tracking-widest mb-3">
        Schedule 2026&nbsp;<span style={{color:'#94a3b8',fontSize:'10px',fontWeight:600,letterSpacing:'0.05em',textTransform:'lowercase'}}>v2.14</span>
      </p>
      <div className="flex items-center gap-2 overflow-x-auto no-scrollbar no-print">
        <button onClick={onHelp} className={`px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 shadow-sm shrink-0 ${activePage === 'help' ? 'bg-red-600 text-white' : 'bg-slate-900 text-white'}`}>
          Help
        </button>
        <button onClick={onTimetable} className={`px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 shadow-sm shrink-0 ${activePage === 'timetable' ? 'bg-red-600 text-white' : 'bg-slate-900 text-white'}`}>
          Timetable
        </button>
        <button onClick={onSchedule} className={`px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 shadow-sm shrink-0 ${activePage === 'schedule' ? 'bg-red-600 text-white' : 'bg-slate-900 text-white'}`}>
          Class Finder
        </button>
        <button onClick={onVenue} className={`px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 shadow-sm shrink-0 ${activePage === 'venue' ? 'bg-red-600 text-white' : 'bg-slate-900 text-white'}`}>
          Venue
        </button>
        <button onClick={() => { window.location.href = '/display'; }} className="px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 bg-slate-900 text-white shadow-sm shrink-0">
          Classic
        </button>
        <button onClick={onShare} className="px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 bg-slate-900 text-white shadow-sm shrink-0">
          Share
        </button>
      </div>
    </header>
  );
}

// ── TIMETABLE VIEW (in-app display.html equivalent) ──────────────────────────
function TimetableView({ events, publishedDates, isAdmin, onSchedule, onVenue, onHelp, onShare }) {
  const toMin = (t) => { if (!t) return 0; const [h, m] = t.split(':').map(Number); return (h < 6 ? h + 24 : h) * 60 + m; };
  const fmt = (t) => { if (!t) return ''; const [h, m] = t.split(':').map(Number); return String(h > 23 ? h - 24 : h).padStart(2,'0') + ':' + String(m).padStart(2,'0'); };

  // Dates visible to this user — admin sees all, public sees only published
  const allDates = [...new Set(events.map(e => e.date))].sort();
  const visibleDates = isAdmin ? allDates : allDates.filter(d => publishedDates.includes(d));

  // Default to last visible date
  const getDefaultDate = () => {
    if (!visibleDates.length) return '';
    const today = new Date().toISOString().slice(0, 10);
    if (visibleDates.includes(today)) return today;
    const past = visibleDates.filter(d => d <= today);
    if (past.length) return past[past.length - 1];
    return visibleDates[0];
  };

  const [selectedDate, setSelectedDate] = useState('');
  const [djMode, setDjMode] = useState(false);

  useEffect(() => {
    if (!selectedDate && visibleDates.length) setSelectedDate(getDefaultDate());
  }, [visibleDates.join(',')]);

  const fmtTabLabel = (dateStr) => {
    const d = new Date(dateStr + 'T12:00:00');
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  };

  // ── Class schedule grid logic ──
  const dayEvts = events.filter(e => e.date === selectedDate);
  const activeRooms = TIMETABLE_ROOM_ORDER.filter(r =>
    dayEvts.some(e => e.room === r && e.category !== 'Closed')
  );
  // Also include rooms not in TIMETABLE_ROOM_ORDER
  const extraRooms = [...new Set(dayEvts.map(e => e.room))]
    .filter(r => !TIMETABLE_ROOM_ORDER.includes(r) && dayEvts.some(e => e.room === r && e.category !== 'Closed'));
  const allActiveRooms = [...activeRooms, ...extraRooms];

  const slotSet = new Set();
  dayEvts.filter(e => e.category !== 'Closed').forEach(e => slotSet.add(e.startTime));
  const candidateSlots = [...slotSet].sort((a, b) => toMin(a) - toMin(b));
  const slots = candidateSlots.filter(slot => {
    const slotMin = toMin(slot);
    return allActiveRooms.some(room => dayEvts.some(e => {
      if (e.room !== room || e.category === 'Closed') return false;
      return slotMin >= toMin(e.startTime) && slotMin < toMin(e.endTime);
    }));
  });
  const spanned = new Set();
  const rowSpans = {};
  slots.forEach((slot, slotIdx) => {
    allActiveRooms.forEach((room, roomIdx) => {
      const key = `${slotIdx}-${roomIdx}`;
      if (spanned.has(key)) return;
      const evt = dayEvts.find(e => e.room === room && e.startTime === slot);
      if (!evt) return;
      const evtEnd = toMin(evt.endTime);
      let span = 1;
      for (let i = slotIdx + 1; i < slots.length; i++) {
        if (toMin(slots[i]) < evtEnd) span++; else break;
      }
      const isSocial = ['Social','Showtime','Star Gate'].includes(evt.category);
      if (isSocial) span = Math.min(span, 3);
      if (span > 1) {
        rowSpans[key] = span;
        for (let s = 1; s < span; s++) spanned.add(`${slotIdx+s}-${roomIdx}`);
      }
    });
  });

  const djRooms = DJ_DATA[selectedDate] || [];

  const dayTabStyle = (date) => ({
    padding: '5px 14px', borderRadius: 6, border: 'none', cursor: 'pointer',
    fontWeight: 800, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.06em',
    whiteSpace: 'nowrap', flexShrink: 0,
    background: date === selectedDate ? '#C20032' : '#334155',
    color: 'white', transition: 'all 0.15s'
  });

  return (
    <div className="min-h-screen bg-slate-100" style={{ fontFamily: "'Segoe UI', sans-serif" }}>
      <SharedHeader
        activePage="timetable"
        onSchedule={onSchedule}
        onTimetable={() => {}}
        onVenue={onVenue}
        onHelp={onHelp}
        onShare={onShare}
        onPoster={() => {}}
      />

      {/* Page heading + Day tabs + Mode toggle */}
      <div className="bg-white border-b border-slate-200 px-4 pt-2 pb-3">
        <h2 style={{ fontSize: 20, fontWeight: 900, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '-0.02em', marginBottom: 10 }}>Timetable</h2>
        {visibleDates.length === 0 ? (
          <p style={{ fontSize: 13, color: '#94a3b8', fontWeight: 600 }}>No published schedule yet.</p>
        ) : (
          <div className="flex items-center gap-2 overflow-x-auto no-scrollbar">
            {visibleDates.map(date => (
              <button key={date} onClick={() => setSelectedDate(date)} style={dayTabStyle(date)}>
                {fmtTabLabel(date)}
                {isAdmin && (
                  <span style={{ marginLeft: 5, fontSize: 9, opacity: 0.7 }}>
                    {publishedDates.includes(date) ? '🟢' : '🔴'}
                  </span>
                )}
              </button>
            ))}
            <button onClick={() => setDjMode(!djMode)}
              style={{
                padding: '5px 14px', borderRadius: 6, border: 'none', cursor: 'pointer',
                fontWeight: 800, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.06em',
                whiteSpace: 'nowrap', flexShrink: 0, transition: 'all 0.15s',
                background: djMode ? '#f59e0b' : '#1e40af',
                color: djMode ? '#0f172a' : 'white'
              }}>
              {djMode ? '📋 Class Schedule' : '🎵 DJ Schedule'}
            </button>
          </div>
        )}
      </div>

      {/* ── DJ SCHEDULE VIEW ── */}
      {djMode && (
        <div style={{ padding: 16 }}>
          {djRooms.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8', fontSize: 14, fontWeight: 700 }}>No DJ data for this day.</div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
              {djRooms.map((room, i) => (
                <div key={i} style={{ background: '#1e293b', borderRadius: 10, overflow: 'hidden' }}>
                  <div style={{ background: '#C20032', color: 'white', fontSize: 14, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.06em', padding: '8px 14px' }}>{room.room}</div>
                  <div style={{ fontSize: 10, fontWeight: 600, color: '#fca5a5', textTransform: 'uppercase', letterSpacing: '0.06em', padding: '4px 14px 6px' }}>{room.genre}</div>
                  {room.slots.map((slot, j) => (
                    <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 14px', borderTop: '1px solid #334155' }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: '#94a3b8', minWidth: 110, whiteSpace: 'nowrap' }}>{slot.time}</div>
                      <div style={{ fontSize: 14, fontWeight: 800, color: 'white', textTransform: 'uppercase', letterSpacing: '0.02em' }}>{slot.dj}</div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* ── CLASS TIMETABLE GRID ── */}
      {!djMode && (
        <div style={{ overflowX: 'auto', overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
          {!selectedDate || slots.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8', fontSize: 14, fontWeight: 700 }}>
              {visibleDates.length === 0 ? 'No published schedule yet.' : 'No schedule data for this day yet.'}
            </div>
          ) : (
            <table className="tt-table">
              <tbody>
                <tr>
                  <th className="tt-th-time">TIME</th>
                  {allActiveRooms.map(r => <th key={r} className="tt-th-room">{r}</th>)}
                </tr>
                {slots.map((slot, slotIdx) => (
                  <tr key={slot} style={{ height: 130 }}>
                    <td className="tt-td-time">{fmt(slot)}</td>
                    {allActiveRooms.map((room, roomIdx) => {
                      const cellKey = `${slotIdx}-${roomIdx}`;
                      if (spanned.has(cellKey)) return null;
                      const evt = dayEvts.find(e => e.room === room && e.startTime === slot);
                      const span = rowSpans[cellKey] || 1;
                      if (!evt) {
                        return <td key={room} className={`tt-td-cell${roomIdx % 2 === 0 ? ' alt' : ''}`} rowSpan={span} />;
                      }
                      const isClosed = evt.category === 'Closed';
                      const isSocial = ['Social','Showtime','Star Gate'].includes(evt.category);
                      const color = CAT_COLOR[evt.category] || '#94a3b8';
                      const cardH = 130 * span - 10;
                      return (
                        <td key={room} className={`tt-td-cell${roomIdx % 2 === 0 ? ' alt' : ''}`} rowSpan={span}>
                          <div className={`tt-card${isClosed ? ' closed' : ''}`}
                            style={{
                              borderLeftColor: isClosed ? '#e2e8f0' : color,
                              background: isClosed ? '#f8fafc' : isSocial ? 'transparent' : hexToTint(color, 0.08),
                              minHeight: cardH
                            }}>
                            {isClosed ? (
                              <span className="tt-closed-text">Closed</span>
                            ) : (
                              <>
                                <div>
                                  <div className="tt-artiste">{evt.artiste || ''}</div>
                                  {cardH > 70 && evt.classTitle && <div className="tt-title">{evt.classTitle}</div>}
                                </div>
                                {cardH > 55 && (
                                  <div className="tt-bottom">
                                    <div className="tt-time">{fmt(evt.startTime)}–{fmt(evt.endTime)}</div>
                                    <div className="tt-level" style={{ background: color }}>{evt.category}</div>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}

// ── UPCOMING EVENTS ──────────────────────────────────────────────────────────
function UpcomingEvents() {
  const [evts, setEvts] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await fetch(
          `https://www.eventbriteapi.com/v3/organizers/${EVENTBRITE_ORGANISER}/events/?status=live&order_by=start_asc&expand=ticket_availability`,
          { headers: { Authorization: `Bearer ${EVENTBRITE_TOKEN}` } }
        );
        if (!res.ok) throw new Error('API error');
        const data = await res.json();
        setEvts(data.events || []);
      } catch (e) { setError(true); }
      finally { setLoading(false); }
    };
    fetchEvents();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' });
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '24px 0', color: '#94a3b8', fontSize: 13 }}>Loading events...</div>;
  if (error || evts.length === 0) return (
    <div style={{ textAlign: 'center', padding: '16px 0' }}>
      <a href="https://www.eventbrite.com/cc/mambo-city-events-2749529" target="_blank" rel="noopener noreferrer"
        style={{ display: 'inline-block', background: '#C20032', color: 'white', borderRadius: 10, padding: '12px 24px', fontSize: 13, fontWeight: 800, textDecoration: 'none', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
        View All Events on Eventbrite →
      </a>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 4, marginBottom: 8 }}>
      {evts.slice(0, 6).map(evt => (
        <a key={evt.id} href={evt.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
          <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', borderRadius: 16, padding: '18px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 10, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.15em', color: '#C20032', marginBottom: 4 }}>{formatDate(evt.start?.local)}</div>
              <div style={{ fontSize: 17, fontWeight: 900, color: 'white', letterSpacing: '-0.02em', lineHeight: 1.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{evt.name?.text}</div>
              <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 3 }}>
                {evt.ticket_availability?.is_sold_out ? '🔴 Sold Out' : evt.ticket_availability?.has_available_tickets ? '🟢 Tickets Available' : 'eventbrite.co.uk'}
              </div>
            </div>
            <div style={{ color: '#C20032', fontSize: 22, fontWeight: 900, marginLeft: 12, flexShrink: 0 }}>→</div>
          </div>
        </a>
      ))}
      <a href="https://www.eventbrite.com/cc/mambo-city-events-2749529" target="_blank" rel="noopener noreferrer"
        style={{ textAlign: 'center', display: 'block', padding: '12px', fontSize: 12, color: '#C20032', fontWeight: 700, textDecoration: 'none', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        View All Events on Eventbrite →
      </a>
    </div>
  );
}

// ── VENUE INFO PAGE ──────────────────────────────────────────────────────────
function VenueInfoPage({ onClose, onHelp, onShare, onTimetable, onSchedule }) {
  const [mapFloor, setMapFloor] = useState('upper');
  const [shareToast, setShareToast] = useState(false);

  const handleShare = async () => {
    const shareData = { title: '5Star Congress', text: 'Check out the 5Star Congress schedule app!', url: 'https://mc5star.web.app' };
    if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
      try { await navigator.share(shareData); } catch (e) {}
    } else {
      try { await navigator.clipboard.writeText('https://mc5star.web.app'); } catch (e) {}
      setShareToast(true); setTimeout(() => setShareToast(false), 2500);
    }
  };

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Segoe UI', sans-serif" }}>
      <SharedHeader
        activePage="venue"
        onSchedule={onSchedule}
        onTimetable={onTimetable}
        onVenue={() => {}}
        onHelp={onHelp}
        onShare={onShare || handleShare}
        onPoster={() => {}}
      />

      <div className="max-w-2xl mx-auto px-4 pb-20 pt-4 venue-section">
        <h2 style={{ fontSize: 22, fontWeight: 900, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '-0.02em', marginBottom: 20, marginTop: 8 }}>Venue &amp; Arrival Info</h2>

        <div style={{ background: '#fff5f7', border: '2px solid #C20032', borderRadius: 12, padding: '14px 16px', marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 800, color: '#C20032', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Share This App</div>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>mc5star.web.app</div>
          </div>
          <button onClick={onShare || handleShare} style={{ background: '#C20032', color: 'white', border: 'none', borderRadius: 10, padding: '10px 18px', fontSize: 12, fontWeight: 800, textTransform: 'uppercase', cursor: 'pointer', flexShrink: 0 }}>Share App</button>
        </div>

        <a href="https://chat.whatsapp.com/HuEjIu714YV3FCSCsRvNP9" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'block', marginBottom: 20 }}>
          <div style={{ background: '#25d366', borderRadius: 12, padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 800, color: 'white', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Join Our WhatsApp Community</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.8)', marginTop: 2 }}>Stay connected with 5Star Congress 2026</div>
            </div>
            <div style={{ fontSize: 22, flexShrink: 0 }}>📱</div>
          </div>
        </a>

        <h3>Location</h3>
        <p style={{ fontSize: 13, color: '#334155', marginBottom: 8 }}>Radisson Blu Hotel, Bath Road, London Heathrow, UB3 5AW</p>

        <h3>Venue Maps</h3>
        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          <button className={`venue-map-tab ${mapFloor === 'upper' ? 'active' : ''}`} onClick={() => setMapFloor('upper')}>Upper Floor</button>
          <button className={`venue-map-tab ${mapFloor === 'ground' ? 'active' : ''}`} onClick={() => setMapFloor('ground')}>Ground Floor</button>
        </div>
        <div style={{ borderRadius: 16, overflow: 'hidden', border: '1px solid #e2e8f0', marginBottom: 16 }}>
          <img src={mapFloor === 'upper' ? MAP_UPPER : MAP_GROUND} alt={`${mapFloor} floor map`} style={{ width: '100%', display: 'block' }} />
        </div>

        <h3>Hotel Check-In / Out</h3>
        <ul>
          <li>Check-in from 3:00 PM</li>
          <li>Check-out by 11:00 AM</li>
          <li>For early check-in, contact the hotel in advance</li>
        </ul>

        <h3>Wristbands</h3>
        <ul>
          <li>Wristbands are required at all times</li>
          <li>Lost wristbands: replacement cost £237</li>
          <li>If uncomfortable, may only be removed by staff and replaced free of charge</li>
        </ul>

        <h3>Water Stations</h3>
        <ul>
          <li>Water stations are available in the Atrium and outside the Royal room during workshops and throughout the evening</li>
          <li>Please bring a refillable bottle</li>
        </ul>

        <h3>Vendors</h3>
        <ul>
          <li><strong>Dance Chill &amp; Recharge</strong> — Massage</li>
          <li><strong>Shoes by Larisa</strong> — Our Sponsors</li>
        </ul>

        <h3>Parties &amp; Socials</h3>
        <p style={{ fontSize: 13, color: '#334155', marginBottom: 6 }}><strong>Theme: Dress to Impress (All Weekend)</strong></p>
        <ul>
          <li><strong>Friday:</strong> Afternoon Social 4 PM – 8 PM | Evening Party from 9 PM | Showtime 10 PM</li>
          <li><strong>Saturday &amp; Sunday:</strong> Afternoon Social 3 PM – 7 PM | Evening Party from 9 PM</li>
          <li><strong>Showcases:</strong> Saturday &amp; Sunday at 5:15 PM — Commonwealth Room</li>
        </ul>

        <h3>Registration Desk</h3>
        <ul>
          <li>Friday 2nd May: 3 PM – 2:30 AM</li>
          <li>Saturday 3rd May: 10:30 AM – 6 PM / 8:30 PM – 3 AM</li>
          <li>Sunday 4th May: 10:30 AM – 6 PM / 8:30 PM – 3 AM</li>
        </ul>

        <h3>Dining</h3>
        <p style={{ fontSize: 13, color: '#334155', marginBottom: 6 }}><strong>10% discount for festival guests on food &amp; beverages</strong></p>
        <ul>
          <li><strong>Breakfast:</strong> 6:00 AM – 11:00 AM (Sat, Sun and Bank Holiday Mon)</li>
          <li><strong>Skyway Brasserie:</strong> Open all day, last orders 9:45 PM — <a href="https://www.opentable.co.uk/r/skyway-brasserie" target="_blank" rel="noopener noreferrer">book a table here</a> (booking advised)</li>
          <li><strong>Bijou Bar:</strong> Opens 5:00 PM | Closes 3:00 AM Friday | Closes 1:00 AM Sat &amp; Sun</li>
          <li><strong>Atrium Bar:</strong> Not open Friday | Open 9:00 PM – 3:00 AM Sat &amp; Sun</li>
          <li><strong>Nearby:</strong> <a href="http://www.pheasant-restaurant.co.uk" target="_blank" rel="noopener noreferrer">The Pheasant Restaurant</a> (5 min walk, closed Sundays)</li>
        </ul>

        <h3>Wi-Fi</h3>
        <ul>
          <li>Free Wi-Fi throughout the hotel</li>
          <li>Lobby has internet workstations</li>
        </ul>

        <h3>Travel &amp; Transport</h3>
        <ul>
          <li><strong>Closest Tube:</strong> Terminals 1–3 (Piccadilly Line)</li>
          <li><strong>Heathrow Express:</strong> Paddington to T1–3 every 15 min</li>
          <li><strong>Buses:</strong> T1–3: 105, 111, 140 | T4: 555 | T5: 423</li>
          <li><strong>Taxi:</strong> ~8 mins (T4), ~10 mins (T5)</li>
          <li><strong>Driving:</strong> From M4 J4, follow signs to T1–3, take A4 on Bath Road</li>
          <li><strong>Other airports:</strong> National Express to Heathrow, then free Red Bus to hotel. Gatwick: 1h 15–30m | Luton: 45m–1h 5m | Stansted: 1h 20–30m. Approx. £20 one way.</li>
        </ul>

        <h3>Car Parking</h3>
        <ul>
          <li><strong>£10 per day</strong> (reduced rate for hotel guests)</li>
          <li>Ticketless system — barrier rises automatically on entry</li>
          <li>Hotel guests: pay at reception on check-in to get the £10 rate</li>
          <li>Day visitors: use the QR code in the conference areas to pay via machine</li>
        </ul>

        <h3>Our Events</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 4, marginBottom: 8 }}>
          {[
            { href: 'https://motioncity.co.uk/', date: 'August 2026', name: 'MotionCity', sub: 'motioncity.co.uk' },
            { href: 'https://mambocity.co.uk/#Festivals', date: 'September 2026', name: 'Sardinia Rhythm & Salsa', sub: 'mambocity.co.uk' },
            { href: 'https://mamboconson.com/', date: 'January 2027', name: 'Mambo Con Son', sub: 'Featuring Eduardo Moreno · mamboconson.com' },
            { href: 'https://5starcongress.com/', date: '30th April – 3rd May 2027', name: '5Star Congress', sub: '25th Anniversary Edition · 5starcongress.com' },
          ].map(e => (
            <a key={e.name} href={e.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
              <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', borderRadius: 16, padding: '18px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontSize: 10, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.15em', color: '#C20032', marginBottom: 4 }}>{e.date}</div>
                  <div style={{ fontSize: 18, fontWeight: 900, color: 'white', letterSpacing: '-0.02em', lineHeight: 1.2 }}>{e.name}</div>
                  <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>{e.sub}</div>
                </div>
                <div style={{ color: '#C20032', fontSize: 22, fontWeight: 900 }}>→</div>
              </div>
            </a>
          ))}
        </div>

        <h3>Buy Tickets</h3>
        <UpcomingEvents />
      </div>
      {shareToast && <div className="share-toast">✓ Link copied — mc5star.web.app</div>}
    </div>
  );
}

// ── HELP PAGE ────────────────────────────────────────────────────────────────
function HelpPage({ onClose, onVenue, onShare, onTimetable, onSchedule }) {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Segoe UI', sans-serif" }}>
      <SharedHeader
        activePage="help"
        onSchedule={onSchedule}
        onTimetable={onTimetable}
        onVenue={onVenue}
        onHelp={() => {}}
        onShare={onShare}
        onPoster={() => {}}
      />

      <div className="max-w-2xl mx-auto px-4 pb-20 pt-4 venue-section">
        <h2 style={{ fontSize: 22, fontWeight: 900, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '-0.02em', marginBottom: 20, marginTop: 8 }}>How to Use the App</h2>

        <h3>Finding Classes</h3>
        <ul>
          <li>The <strong>Timetable</strong> shows the full day at a glance — all rooms side by side, colour coded by level. Swipe left and right to scroll across rooms, swipe up and down to move through the day.</li>
          <li>The <strong>Class Finder</strong> is your interactive search and filter tool. Use it to search by instructor, filter by level, find On1-friendly classes, or build your personal schedule. Tap the Class Finder button in the nav to open it.</li>
          <li>In Class Finder, use the <strong>Search bar</strong> to find any instructor or class title instantly as you type</li>
          <li>Tap <strong>Levels</strong> to filter by your level — Beginners, Improvers, Intermediate, Advanced and more</li>
          <li>Tap <strong>On1 Friendly</strong> to show only classes suitable for On1 style dancers</li>
          <li>Tap <strong>My Schedule</strong> to see only the classes you have starred</li>
          <li>Tap <strong>List / Grid</strong> to switch between a scrollable card list and a room-by-room grid layout</li>
          <li>Tap <strong>Reset</strong> at any time to clear all filters and start fresh</li>
        </ul>

        <h3>Starring Classes</h3>
        <ul>
          <li>Tap the <strong>★ star icon</strong> on any class card to save it to your schedule</li>
          <li>Tap <strong>My Schedule</strong> in the filter bar to see only your starred classes</li>
          <li>If you star two classes at the same time the app will warn you about the clash — you can override it or pick one</li>
          <li>Your stars are stored on your device only — not shared with anyone</li>
        </ul>

        <h3>Class Info and Room Finder</h3>
        <ul>
          <li>Tap the <strong>Info</strong> button on any class card to see the full description and instructor photo</li>
          <li>Tap <strong>Locate Room</strong> inside the Info panel to see a floor plan with your room highlighted</li>
        </ul>

        <h3>Classic View</h3>
        <ul>
          <li>Tap <strong>Classic</strong> in the header for the large-screen kiosk display</li>
          <li>Designed for big screens at the venue — includes a live clock and DJ schedule</li>
          <li>Tap <strong>← Back</strong> to return to the app</li>
        </ul>

        <h3>On1 Friendly Filter</h3>
        <ul>
          <li>Tap <strong>On1 Friendly</strong> in the filter bar to show only classes suitable for On1 style</li>
          <li>Look for the <strong>On1 ⭐</strong> badge on class cards</li>
        </ul>

        <h3>Live Updates</h3>
        <ul>
          <li>The schedule is connected to a live database</li>
          <li>If anything changes over the weekend — room swaps, timing adjustments — your app updates automatically</li>
          <li>No refreshing needed, no out of date paper programme</li>
        </ul>

        <h3>Rate Classes</h3>
        <ul>
          <li>Tap <strong>Info</strong> on any card and scroll to the bottom to leave a star rating</li>
          <li>Ratings are anonymous and help shape the programme for future events</li>
          <li>The rating feature switches on from Friday evening once classes begin</li>
        </ul>

        <h3>Share the App</h3>
        <ul>
          <li>Tap <strong>Share</strong> in the header to send the app link via WhatsApp, Messages, email or any app on your phone</li>
          <li>Help spread the word so everyone at the congress has the schedule in their pocket</li>
        </ul>

        <h3>Colour Guide</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 }}>
          {[
            { color: '#f97316', label: 'Orange', desc: 'Beginners / Beginners to Improvers' },
            { color: '#fde047', label: 'Yellow', desc: 'Improvers / Improvers to Intermediate' },
            { color: '#3b82f6', label: 'Blue',   desc: 'Intermediate' },
            { color: '#f43f5e', label: 'Red',    desc: 'Advanced' },
            { color: '#22c55e', label: 'Green',  desc: 'Intermediate to Advanced' },
            { color: '#ca8a04', label: 'Gold',   desc: 'Progressive (two-hour workshops)' },
            { color: '#a855f7', label: 'Purple', desc: 'All Levels' },
            { color: '#06b6d4', label: 'Cyan',   desc: 'Social (afternoon and evening parties)' },
            { color: '#d946ef', label: 'Fuchsia',desc: 'Showtime' },
            { color: '#f59e0b', label: 'Amber',  desc: 'Star Gate' },
            { color: '#94A3B8', label: 'Grey',   desc: 'Closed or not in use' },
          ].map(({ color, label, desc }) => (
            <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 18, height: 18, borderRadius: 4, background: color, flexShrink: 0, border: '1px solid rgba(0,0,0,0.08)' }}></div>
              <span style={{ fontSize: 13, color: '#334155' }}><strong>{label}</strong> — {desc}</span>
            </div>
          ))}
        </div>

        <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, padding: '14px 16px', marginTop: 8 }}>
          <div style={{ fontSize: 12, fontWeight: 800, color: '#0f172a', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>One last tip</div>
          <div style={{ fontSize: 13, color: '#64748b' }}>Install the app on your home screen before you leave home. It loads faster and gives you the best experience throughout the weekend. Make sure you have Wi-Fi or mobile data at the venue to keep the schedule live and up to date.</div>
        </div>

        <div style={{ marginTop: 24 }}>
          <button onClick={onClose}
            style={{ width: '100%', background: '#0f172a', color: 'white', border: 'none', borderRadius: 16, padding: '16px', fontSize: 13, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.06em', cursor: 'pointer' }}>
            → Go to Timetable
          </button>
        </div>
      </div>
    </div>
  );
}

// ── MAIN APP ─────────────────────────────────────────────────────────────────
function App() {
  const [events, setEvents] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAdminForm, setShowAdminForm] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showMapMode, setShowMapMode] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [on1Only, setOn1Only] = useState(false);
  const [myStarsOnly, setMyStarsOnly] = useState(false);
  const [showJumpTop, setShowJumpTop] = useState(false);
  const [showVenueInfo, setShowVenueInfo] = useState(false);
  const [showTimetable, setShowTimetable] = useState(() => !!localStorage.getItem('5star_help_seen'));
  const [showHelpPage, setShowHelpPage] = useState(() => !localStorage.getItem('5star_help_seen'));
  const [shareToast, setShareToast] = useState(false);
  const [publishedDates, setPublishedDates] = useState([]);
  const [starredIds, setStarredIds] = useState(() => {
    const saved = localStorage.getItem('5star_starred_v32');
    return saved ? JSON.parse(saved) : [];
  });
  const [userRatings, setUserRatings] = useState(() => {
    const saved = localStorage.getItem('5star_ratings_v1');
    return saved ? JSON.parse(saved) : {};
  });
  const [currentTime, setCurrentTime] = useState(new Date());
  const [lastUpdated, setLastUpdated] = useState(null);
  const [viewDate, setViewDate] = useState('2026-05-01');
  const [selectedDay, setSelectedDay] = useState("All");
  const [useListView, setUseListView] = useState(true);
  const [isGlobalRatingEnabled, setIsGlobalRatingEnabled] = useState(false);
  const [ratingsData, setRatingsData] = useState([]);
  const [showRatings, setShowRatings] = useState(false);

  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    date: '2026-05-01', startTime: '11:00', endTime: '11:50',
    room: 'Atrium 1', category: 'All Levels', artiste: '',
    classTitle: '', longDescription: '', isOn1Friendly: false
  });

  useEffect(() => { localStorage.setItem('5star_ratings_v1', JSON.stringify(userRatings)); }, [userRatings]);
  useEffect(() => { localStorage.setItem('5star_starred_v32', JSON.stringify(starredIds)); }, [starredIds]);

  useEffect(() => {
    const handleScroll = () => setShowJumpTop(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    onAuthStateChanged(auth, (u) => setIsAdmin(!!u));
    const unsubSchedule = onSnapshot(collection(db, "schedule"), (s) => {
      const data = s.docs.map(d => ({ id: d.id, ...d.data() }));
      setEvents(data.sort((a, b) => a.startTime.localeCompare(b.startTime)));
      setLastUpdated(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
    });
    let unsubSettings = () => {};
    try {
      unsubSettings = onSnapshot(doc(db, "settings", "globalConfig"), (docSnap) => {
        if (docSnap.exists()) {
          setIsGlobalRatingEnabled(docSnap.data().isRatingEnabled || false);
          setPublishedDates(docSnap.data().publishedDates || []);
        }
      });
    } catch (e) { console.warn("Settings blocked locally."); }
    const timer = setInterval(() => setCurrentTime(new Date()), 30000);
    return () => { unsubSchedule(); unsubSettings(); clearInterval(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMinutes = (timeStr) => {
    if (!timeStr) return 0;
    const [h, m] = timeStr.split(':').map(Number);
    return (h < 6 ? h + 24 : h) * 60 + m;
  };

  const renderFormattedArtiste = (name) => {
    if (!name) return "";
    return name.split(',').map((part, index, array) => (
      <React.Fragment key={index}>
        <span className="keep-together">{part.trim()}</span>
        {index < array.length - 1 && ", "}
      </React.Fragment>
    ));
  };

  const isLive = (eventDate, startTime, endTime) => {
    const now = currentTime;
    const todayStr = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
    if (eventDate !== todayStr) return false;
    const h = now.getHours();
    const nowMin = (h < 6 ? h + 24 : h) * 60 + now.getMinutes();
    return nowMin >= getMinutes(startTime) && nowMin < getMinutes(endTime);
  };

  const handleStartTimeChange = (start) => {
    if (!start) return;
    const [h, m] = start.split(':').map(Number);
    let totalMin = h * 60 + m + 50;
    let endH = Math.floor(totalMin / 60) % 24;
    let endM = totalMin % 60;
    setFormData({ ...formData, startTime: start, endTime: `${String(endH).padStart(2,'0')}:${String(endM).padStart(2,'0')}` });
  };

  const handleSaveEvent = async (e) => {
    e.preventDefault();
    const hasConflict = events.some(evt => {
      if (editingId && evt.id === editingId) return false;
      if (evt.date !== formData.date || evt.room !== formData.room) return false;
      return (getMinutes(formData.startTime) < getMinutes(evt.endTime) && getMinutes(formData.endTime) > getMinutes(evt.startTime));
    });
    if (hasConflict) { alert("⚠️ GRID POSITION OCCUPIED"); return; }
    try {
      if (editingId) { await updateDoc(doc(db, "schedule", editingId), formData); setEditingId(null); }
      else { await addDoc(collection(db, "schedule"), formData); }
      setShowAdminForm(false);
    } catch (err) { alert("Save failed."); }
  };

  const handleLogin = async () => {
    const e = prompt("Email:"), p = prompt("Pass:");
    if (e && p) signInWithEmailAndPassword(auth, e, p).catch(err => alert(err.message));
  };

  const handleDownloadBackup = () => {
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(events, null, 2));
    const dlNode = document.createElement('a');
    dlNode.setAttribute("href", dataStr);
    dlNode.setAttribute("download", `5star_backup_${new Date().toLocaleDateString()}.json`);
    dlNode.click();
  };

  const handleRestoreBackup = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (ev) => {
      try {
        const imported = JSON.parse(ev.target.result);
        if (window.confirm(`Restore ${imported.length} entries?`)) {
          const snap = await getDocs(collection(db, "schedule"));
          const batch = writeBatch(db);
          snap.forEach(d => batch.delete(d.ref));
          await batch.commit();
          const addBatch = writeBatch(db);
          imported.forEach(item => { const { id, ...cleanItem } = item; addBatch.set(doc(collection(db, "schedule")), cleanItem); });
          await addBatch.commit();
        }
      } catch (err) { alert("Error."); }
    };
    reader.readAsText(file);
  };

  const handleClearAll = async () => {
    if (window.confirm("⚠️ Wipe database?")) {
      const snap = await getDocs(collection(db, "schedule"));
      const batch = writeBatch(db);
      snap.forEach(d => batch.delete(d.ref));
      await batch.commit();
    }
  };

  const handleDeleteEvent = async (id) => {
    if (!window.confirm("Delete?")) return;
    try { await deleteDoc(doc(db, "schedule", id)); } catch (err) { alert("Fail."); }
  };

  const startEditing = (evt) => {
    setEditingId(evt.id);
    setFormData({ date: evt.date, startTime: evt.startTime, endTime: evt.endTime, room: evt.room, category: evt.category, artiste: evt.artiste, classTitle: evt.classTitle, longDescription: evt.longDescription || '', isOn1Friendly: evt.isOn1Friendly || false });
    setShowAdminForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const toggleStar = (id) => {
    if (starredIds.includes(id)) { setStarredIds(prev => prev.filter(i => i !== id)); return; }
    const newEvt = events.find(e => e.id === id);
    if (newEvt) {
      const clashes = events.filter(e => starredIds.includes(e.id) && e.date === newEvt.date && getMinutes(e.startTime) < getMinutes(newEvt.endTime) && getMinutes(e.endTime) > getMinutes(newEvt.startTime));
      if (clashes.length > 0) {
        const names = clashes.map(e => `${e.artiste} (${e.startTime})`).join(', ');
        if (!window.confirm(`⚠️ Time clash!\n\n${newEvt.artiste} at ${newEvt.startTime} clashes with:\n${names}\n\nStar it anyway?`)) return;
      }
    }
    setStarredIds(prev => [...prev, id]);
  };

  const fetchRatings = async () => {
    const snap = await getDocs(collection(db, "ratings"));
    const raw = snap.docs.map(d => d.data());
    const grouped = {};
    raw.forEach(r => {
      if (!grouped[r.artiste]) grouped[r.artiste] = { artiste: r.artiste, total: 0, count: 0 };
      grouped[r.artiste].total += r.score; grouped[r.artiste].count += 1;
    });
    const result = Object.values(grouped).map(g => ({ artiste: g.artiste, avg: g.total / g.count, count: g.count })).sort((a, b) => b.avg - a.avg);
    setRatingsData(result); setShowRatings(true);
  };

  const handleRateClass = async (eventId, artiste, score) => {
    if (userRatings[eventId]) return;
    setUserRatings(prev => ({ ...prev, [eventId]: score }));
    try { await addDoc(collection(db, "ratings"), { eventId, artiste, score, timestamp: new Date().toISOString() }); }
    catch (err) { console.error("Failed to log rating"); }
  };

  const handleShareApp = async () => {
    const shareData = { title: '5Star Congress', text: 'Check out the 5Star Congress 2026 schedule app — all classes, rooms and timings on your phone!', url: 'https://mc5star.web.app' };
    if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
      try { await navigator.share(shareData); } catch (e) {}
    } else {
      try { await navigator.clipboard.writeText('https://mc5star.web.app'); } catch (e) {}
      setShareToast(true); setTimeout(() => setShareToast(false), 2500);
    }
  };

  // Shared nav callbacks
  const goSchedule = () => { setShowVenueInfo(false); setShowHelpPage(false); setShowTimetable(false); window.scrollTo(0,0); };
  const goTimetable = () => { setShowVenueInfo(false); setShowHelpPage(false); setShowTimetable(true); window.scrollTo(0,0); };
  const goVenue = () => { setShowTimetable(false); setShowHelpPage(false); setShowVenueInfo(true); window.scrollTo(0,0); };
  const goHelp = () => { setShowVenueInfo(false); setShowTimetable(false); setShowHelpPage(true); window.scrollTo(0,0); };

  const filteredEvents = events.filter(evt => {
    if (myStarsOnly && !starredIds.includes(evt.id)) return false;
    const s = searchQuery.toLowerCase().trim();
    const matchesSearch = s === "" || (evt.artiste || "").toLowerCase().includes(s) || (evt.classTitle || "").toLowerCase().includes(s);
    const matchesCategory = selectedCategory === "All" || evt.category === selectedCategory;
    const matchesOn1 = on1Only ? evt.isOn1Friendly : true;
    return matchesSearch && matchesCategory && matchesOn1;
  });

  const allEventDates = [...new Set([...filteredEvents.map(e => e.date), viewDate])].sort();
  const dates = isAdmin ? allEventDates : allEventDates.filter(d => publishedDates.includes(d));

  // ── Page routing ──
  if (showHelpPage) return (
    <HelpPage
      onClose={() => { localStorage.setItem('5star_help_seen', '1'); setShowHelpPage(false); setShowTimetable(true); window.scrollTo(0,0); }}
      onSchedule={goSchedule}
      onTimetable={goTimetable}
      onVenue={goVenue}
      onHelp={() => {}}
      onShare={handleShareApp}
    />
  );

  if (showTimetable) return (
    <TimetableView
      events={events}
      publishedDates={publishedDates}
      isAdmin={isAdmin}
      onSchedule={goSchedule}
      onVenue={goVenue}
      onHelp={goHelp}
      onShare={handleShareApp}
    />
  );

  if (showVenueInfo) return (
    <VenueInfoPage
      onClose={goSchedule}
      onSchedule={goSchedule}
      onTimetable={goTimetable}
      onHelp={goHelp}
      onShare={handleShareApp}
    />
  );

  // ── Schedule view ──
  return (
    <div className="min-h-screen bg-slate-100 font-sans text-slate-900 pb-20 overflow-x-hidden">

      <div className={`isolation-blur-container ${selectedEvent ? 'is-blurred' : ''}`}>

        {/* HEADER */}
        <header className="max-w-full mx-auto mb-2 bg-white px-4 pt-4 pb-3 md:px-6 md:pt-5 md:pb-4 rounded-2xl shadow-sm border border-slate-200 sticky top-0 z-50">
          <div className="flex justify-between items-center mb-1">
            <h1 className="text-2xl md:text-3xl font-black tracking-tighter uppercase leading-none text-slate-900">5Star Congress</h1>
            <button onClick={() => isAdmin ? signOut(auth) : handleLogin()} className="text-2xl no-print">{isAdmin ? '🔓' : '🔒'}</button>
          </div>
          <p className="text-[9px] font-bold text-red-600 uppercase tracking-widest mb-3">
            Schedule 2026&nbsp;<span style={{color:'#94a3b8',fontSize:'10px',fontWeight:600,letterSpacing:'0.05em',textTransform:'lowercase'}}>v2.14</span>
          </p>
          <div className="flex items-center gap-2 overflow-x-auto no-scrollbar no-print">
            <button onClick={goHelp} className="px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 bg-slate-900 text-white shadow-sm shrink-0">Help</button>
            <button onClick={goTimetable} className="px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 bg-slate-900 text-white shadow-sm shrink-0">Timetable</button>
            <button onClick={goSchedule} className="px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 bg-red-600 text-white shadow-sm shrink-0">Class Finder</button>
            <button onClick={goVenue} className="px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 bg-slate-900 text-white shadow-sm shrink-0">Venue</button>
            <button onClick={() => { window.location.href = '/display'; }} className="px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 bg-slate-900 text-white shadow-sm shrink-0">Classic</button>
            <button onClick={handleShareApp} className="px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 bg-slate-900 text-white shadow-sm shrink-0">Share</button>
            {isAdmin && <button onClick={() => window.print()} className="bg-slate-900 text-white px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest shadow-sm active:scale-95 transition-all hidden md:block shrink-0">Print</button>}
          </div>
        </header>

        {/* FILTER BAR */}
        <div className="sticky-filter-bar p-3 mb-4 no-print">
          <div className="flex flex-col gap-3">
            <div className="flex gap-2">
              <input placeholder="🔍 Search..." className="flex-1 bg-white p-3 md:p-4 rounded-2xl text-sm font-bold ring-1 ring-slate-200 outline-none shadow-sm" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
              <button onClick={() => { setSearchQuery(""); setSelectedCategory("All"); setOn1Only(false); setMyStarsOnly(false); }} className="bg-slate-100 px-5 rounded-2xl text-[10px] font-black uppercase border border-slate-200 active:bg-slate-200">Reset</button>
              <button onClick={() => setUseListView(!useListView)} className={`px-5 rounded-2xl text-[10px] font-black uppercase border shadow-sm transition-all ${useListView ? 'bg-slate-900 text-white border-slate-900' : 'bg-white border-slate-200 text-slate-400'}`}>{useListView ? '☰ List' : '⊞ Grid'}</button>
            </div>
            {!myStarsOnly && <p className="text-[9px] font-bold text-slate-400 uppercase tracking-widest px-1">★ Star classes to build your personal schedule</p>}
            <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
              <button onClick={() => setMyStarsOnly(!myStarsOnly)} className={`px-6 py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all shrink-0 shadow-sm ${myStarsOnly ? 'bg-amber-400 text-amber-950' : 'bg-white border border-slate-200 text-slate-400'}`}>★ My Schedule</button>
              <select className="px-5 py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest border border-slate-200 outline-none bg-white shadow-sm" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                <option value="All">Levels</option>
                {Object.keys(EVENT_COLORS).sort().map(cat => <option key={cat} value={cat}>{cat}</option>)}
              </select>
              <button onClick={() => setOn1Only(!on1Only)} className={`px-6 py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all shrink-0 shadow-sm ${on1Only ? 'bg-blue-600 text-white' : 'bg-white border border-slate-200 text-slate-400'}`}>ON1 Friendly</button>
            </div>
          </div>
        </div>

        {/* ADMIN */}
        {isAdmin && (
          <div className="max-w-2xl mx-auto mb-10 bg-white p-8 rounded-[2.5rem] shadow-2xl border-4 border-blue-100 no-print">
            <div className="flex justify-between items-center mb-6 text-xs font-black uppercase text-blue-600">Admin Console
              <div className="flex gap-2 items-center">
                <button onClick={handleDownloadBackup} className="text-[10px] font-bold uppercase bg-slate-100 px-3 py-1 rounded border">Export</button>
                <button onClick={() => fileInputRef.current.click()} className="text-[10px] font-bold uppercase bg-slate-900 text-white px-3 py-1 rounded">Import</button>
                <button onClick={handleClearAll} className="text-[10px] font-bold uppercase bg-red-600 text-white px-3 py-1 rounded">Wipe</button>
                <input type="file" ref={fileInputRef} className="hidden" onChange={handleRestoreBackup} />
                <input type="date" value={viewDate} onChange={(e) => setViewDate(e.target.value)} className="text-[10px] p-1 border rounded" />
              </div>
            </div>
            <div className="mb-6 bg-slate-50 rounded-2xl p-4 border border-slate-200">
              <div className="text-xs font-black uppercase tracking-widest text-slate-900 mb-3">📅 Publish Schedule by Date</div>
              <div className="text-[9px] font-bold text-slate-400 uppercase mb-3">Green = Live to public · Red = Draft (admin only)</div>
              {[...new Set(events.map(e => e.date))].sort().map(date => {
                const isPublished = publishedDates.includes(date);
                const label = new Date(date + 'T12:00:00').toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
                return (
                  <div key={date} className="flex items-center justify-between py-2 border-b border-slate-200 last:border-0">
                    <div>
                      <div className="text-xs font-black text-slate-900">{label}</div>
                      <div className="text-[9px] font-bold uppercase" style={{ color: isPublished ? '#22c55e' : '#f43f5e' }}>
                        {isPublished ? '🟢 Published — visible to all' : '🔴 Draft — admin only'}
                      </div>
                    </div>
                    <button onClick={async () => {
                      const updated = isPublished
                        ? publishedDates.filter(d => d !== date)
                        : [...publishedDates, date];
                      await setDoc(doc(db, 'settings', 'globalConfig'), { publishedDates: updated }, { merge: true });
                    }} className={`px-4 py-2 rounded-full text-[10px] font-black uppercase shadow-sm transition-all ${isPublished ? 'bg-red-100 text-red-600 border border-red-200' : 'bg-green-100 text-green-700 border border-green-200'}`}>
                      {isPublished ? 'Unpublish' : 'Publish'}
                    </button>
                  </div>
                );
              })}
              {events.length === 0 && <div className="text-[11px] text-slate-400 text-center py-2">No events in database yet.</div>}
            </div>
            <div className="flex justify-between items-center mb-4 bg-slate-50 p-4 rounded-xl border border-slate-200">
              <div>
                <div className="text-xs font-black uppercase tracking-widest text-slate-900">⭐ Live Rating System</div>
                <div className="text-[9px] font-bold text-slate-400 uppercase mt-1">Allows users to submit class feedback</div>
              </div>
              <button onClick={async () => { await setDoc(doc(db,"settings","globalConfig"),{isRatingEnabled:!isGlobalRatingEnabled},{merge:true}); }} className={`px-6 py-3 rounded-full text-[10px] font-black uppercase shadow-sm transition-all ${isGlobalRatingEnabled ? 'bg-amber-400 text-amber-950 border-2 border-amber-500' : 'bg-slate-200 text-slate-400'}`}>
                {isGlobalRatingEnabled ? 'ON (Visible)' : 'OFF (Hidden)'}
              </button>
            </div>
            <button onClick={fetchRatings} className="w-full bg-amber-400 text-amber-950 py-3 rounded-2xl font-black uppercase text-xs mb-4">⭐ View Ratings Dashboard</button>
            {showRatings && ratingsData.length > 0 && (
              <button onClick={async () => {
                if (!window.confirm('⚠️ Reset ALL ratings?')) return;
                const snap = await getDocs(collection(db, 'ratings'));
                const batch = writeBatch(db);
                snap.forEach(d => batch.delete(d.ref));
                await batch.commit();
                setRatingsData([]); setShowRatings(false);
              }} className="w-full bg-red-600 text-white py-3 rounded-2xl font-black uppercase text-xs mb-4">🗑 Reset All Ratings</button>
            )}
            {showRatings && ratingsData.length > 0 && (
              <div className="mb-6 bg-slate-50 rounded-2xl p-4 border border-slate-200">
                <div className="grid grid-cols-3 gap-3 mb-4">
                  {[{label:'Classes rated',val:ratingsData.length},{label:'Total votes',val:ratingsData.reduce((a,r)=>a+r.count,0)},{label:'Overall avg',val:(ratingsData.reduce((a,r)=>a+r.avg,0)/ratingsData.length).toFixed(1)}].map(s=>(
                    <div key={s.label} className="bg-white rounded-xl p-3 text-center border border-slate-100">
                      <div className="text-[9px] font-black uppercase text-slate-400 mb-1">{s.label}</div>
                      <div className="text-xl font-black text-slate-900">{s.val}</div>
                    </div>
                  ))}
                </div>
                {ratingsData.map((r,i)=>(
                  <div key={i} className="flex justify-between items-center py-2 border-b border-slate-100 last:border-0">
                    <div className="flex-1 mr-3">
                      <div className="text-xs font-black text-slate-900 truncate">{r.artiste}</div>
                      <div className="mt-1 h-1 rounded-full bg-slate-200 overflow-hidden"><div className="h-full rounded-full bg-amber-400" style={{width:`${(r.avg/5)*100}%`}}></div></div>
                    </div>
                    <div className="text-xs font-black text-amber-500 mr-2">{r.avg.toFixed(1)}</div>
                    <div className="text-[9px] text-slate-400 uppercase font-black mr-2">{r.count} votes</div>
                    <button onClick={async () => {
                      if (!window.confirm(`Reset ratings for ${r.artiste}?`)) return;
                      const snap = await getDocs(collection(db, 'ratings'));
                      const batch = writeBatch(db);
                      snap.docs.filter(d => d.data().artiste === r.artiste).forEach(d => batch.delete(d.ref));
                      await batch.commit();
                      setRatingsData(prev => prev.filter(x => x.artiste !== r.artiste));
                    }} className="text-[8px] font-black text-red-500 uppercase bg-red-50 px-2 py-0.5 rounded hover:bg-red-100">Reset</button>
                  </div>
                ))}
              </div>
            )}
            {showRatings && ratingsData.length === 0 && <div className="mb-6 bg-slate-50 rounded-2xl p-6 border border-slate-200 text-center"><div className="text-xs font-black uppercase text-slate-400">No ratings submitted yet</div></div>}
            <button onClick={() => { setShowAdminForm(!showAdminForm); setEditingId(null); }} className="w-full bg-blue-600 text-white py-4 rounded-2xl font-black uppercase text-xs mb-4">{showAdminForm ? 'Close Editor' : 'Add New Entry +'}</button>
            {showAdminForm && (
              <form onSubmit={handleSaveEvent} className="space-y-4">
                <input type="date" value={formData.date} onChange={e=>setFormData({...formData,date:e.target.value})} className="w-full p-4 rounded-xl bg-slate-50 border font-bold" />
                <div className="grid grid-cols-2 gap-4">
                  <input type="time" value={formData.startTime} onChange={e=>handleStartTimeChange(e.target.value)} className="p-4 rounded-xl bg-slate-50 border font-bold" />
                  <input type="time" value={formData.endTime} onChange={e=>setFormData({...formData,endTime:e.target.value})} className="p-4 rounded-xl bg-slate-50 border font-bold" />
                </div>
                <div className="flex items-center gap-3 p-4 bg-blue-50 rounded-xl border border-blue-100">
                  <input type="checkbox" id="on1" className="w-5 h-5" checked={formData.isOn1Friendly} onChange={e=>setFormData({...formData,isOn1Friendly:e.target.checked})} />
                  <label htmlFor="on1" className="font-black text-xs uppercase text-blue-900">Suitable for On1</label>
                </div>
                <select value={formData.room} onChange={e=>setFormData({...formData,room:e.target.value})} className="w-full p-4 rounded-xl bg-slate-50 border font-bold">{ROOM_LIST.map(r=><option key={r} value={r}>{r}</option>)}</select>
                <select value={formData.category} onChange={e=>setFormData({...formData,category:e.target.value})} className="w-full p-4 rounded-xl bg-slate-50 border font-bold">{Object.keys(EVENT_COLORS).map(c=><option key={c} value={c}>{c}</option>)}</select>
                <input list="artist-list" placeholder="Artiste" value={formData.artiste} onChange={e=>setFormData({...formData,artiste:e.target.value})} className="w-full p-4 rounded-xl bg-slate-50 border font-black" />
                <datalist id="artist-list">{ARTIST_LIBRARY.map(a=><option key={a} value={a}/>)}</datalist>
                <input placeholder="Title" value={formData.classTitle} onChange={e=>setFormData({...formData,classTitle:e.target.value})} className="w-full p-4 rounded-xl bg-slate-50 border font-bold" />
                <textarea placeholder="Full Description" value={formData.longDescription} onChange={e=>setFormData({...formData,longDescription:e.target.value})} className="w-full p-4 bg-slate-50 rounded-xl border h-24 font-bold" />
                <button type="submit" className="w-full bg-slate-900 text-white py-5 rounded-2xl font-black uppercase">Save</button>
              </form>
            )}
          </div>
        )}

        {/* SCHEDULE DAYS */}
        {dates.map(date => {
          const dEvts = filteredEvents.filter(e => e.date === date);
          const dayRooms = ROOM_LIST.filter(r => dEvts.some(e => e.room === r));
          const activeHours = new Set();
          dEvts.forEach(evt => activeHours.add(Math.floor(getMinutes(evt.startTime) / 60)));
          const sortedHours = Array.from(activeHours).sort((a, b) => a - b);
          if (dEvts.length === 0 && myStarsOnly) return null;
          const showAsGrid = !useListView;

          return (
            <div key={date} className="mb-16 bg-white rounded-[2.5rem] shadow-2xl overflow-hidden mx-2 md:mx-6">
              <div className="bg-slate-900 text-white p-6 md:p-10 flex justify-between items-center">
                <h2 className="text-lg md:text-3xl font-black uppercase tracking-[0.2em]">
                  {new Date(date + 'T12:00:00').toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' })}
                </h2>
              </div>
              <div className={`p-2 md:p-6 bg-slate-50 ${!showAsGrid ? 'itinerary-list-container' : 'overflow-x-auto'}`}>
                {!showAsGrid ? (
                  dEvts.map(evt => {
                    const hexColor = COLOR_MAP[EVENT_COLORS[evt.category]];
                    const live = isLive(evt.date, evt.startTime, evt.endTime);
                    const isStarred = starredIds.includes(evt.id);
                    return (
                      <div key={evt.id} className={`card-premium p-6 md:p-8 ${live ? 'live-pulse' : ''}`} style={{ color: hexColor }}>
                        <div className="flex justify-between items-start ml-4 relative z-10">
                          <div className="text-xs font-black uppercase opacity-50 tracking-widest text-sub">{evt.startTime} - {evt.endTime}</div>
                          <button onClick={() => toggleStar(evt.id)} className="text-3xl active:scale-150 transition-transform no-print">{isStarred ? '★' : '☆'}</button>
                        </div>
                        <div className="bg-slate-900 text-white self-start px-4 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest shadow-md ml-4 mt-2 relative z-10">Room: {evt.room}</div>
                        <div className="text-xl md:text-2xl font-black tracking-tighter leading-tight ml-4 mt-4 text-main">{renderFormattedArtiste(evt.artiste)}</div>
                        <div className="text-sm md:text-base font-bold italic opacity-70 uppercase tracking-tight ml-4 text-sub">{evt.classTitle}</div>
                        <div className="flex justify-between items-center mt-6 pt-4 border-t border-black/5 relative z-10 ml-4">
                          <div className="flex gap-1.5 items-center">
                            <span onClick={() => { setSelectedCategory(evt.category); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="bg-slate-50 border border-slate-200 text-[9px] font-black px-2 py-0.5 rounded uppercase text-sub cursor-pointer hover:bg-slate-200">{evt.category}</span>
                            {evt.isOn1Friendly && <span className="text-[9px] font-black text-blue-600 uppercase">On1 ⭐</span>}
                            {isAdmin && <div className="flex gap-2 no-print"><button onClick={() => startEditing(evt)} className="text-[8px] font-black text-blue-600 uppercase bg-blue-50 px-2 py-0.5 rounded">Edit</button><button onClick={() => handleDeleteEvent(evt.id)} className="text-[8px] font-black text-red-600 uppercase bg-red-50 px-2 py-0.5 rounded">Del</button></div>}
                          </div>
                          <button onClick={() => { setSelectedEvent(evt); setShowMapMode(false); }} className="bg-slate-50 text-slate-900 text-[9px] px-3 py-1 rounded-full font-black uppercase border border-slate-200 shadow-sm active:scale-95 transition-transform no-print">Info</button>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="schedule-grid-container" style={{ gridTemplateColumns: `60px repeat(${dayRooms.length}, minmax(280px, 1fr))`, gridTemplateRows: `60px repeat(${sortedHours.length}, minmax(160px, auto))` }}>
                    <div className="grid-header grid-time-label">Time</div>
                    {dayRooms.map((r, i) => <div key={r} className="grid-header" style={{ gridColumn: i + 2, gridRow: 1 }}>{r}</div>)}
                    {sortedHours.map((h, i) => <div key={`bg-${h}`} className="grid-bg-cell no-print" style={{ gridRow: i + 2 }}></div>)}
                    {sortedHours.map((h, i) => <div key={h} className="grid-time-label" style={{ gridColumn: 1, gridRow: i + 2 }}>{h > 23 ? h - 24 : h}:00</div>)}
                    {dEvts.map(evt => {
                      const startMin = getMinutes(evt.startTime);
                      const isStarred = starredIds.includes(evt.id);
                      const live = isLive(evt.date, evt.startTime, evt.endTime);
                      const maxSpan = evt.category === 'Social' ? 3 : evt.category === 'Progressive' ? 2 : 1;
                      const durationHrs = Math.min(maxSpan, Math.max(1, Math.ceil((getMinutes(evt.endTime) - startMin) / 60)));
                      const rowStart = sortedHours.indexOf(Math.floor(startMin / 60)) + 2;
                      const colIndex = dayRooms.indexOf(evt.room) + 2;
                      const hexColor = COLOR_MAP[EVENT_COLORS[evt.category]];
                      return (
                        <div key={evt.id} className={`card-premium m-1.5 p-5 md:p-6 z-20 ${isStarred ? 'star-pinned' : ''} ${live ? 'live-pulse' : ''}`} style={{ gridColumn: colIndex, gridRow: `${rowStart} / span ${durationHrs}`, color: hexColor }}>
                          <div className="flex justify-between items-start relative z-10 ml-4">
                            <div className="text-[9px] font-black opacity-40 uppercase tracking-tighter text-sub">{evt.startTime} - {evt.endTime}</div>
                            <button onClick={() => toggleStar(evt.id)} className="text-xl active:scale-150 transition-transform opacity-60 hover:opacity-100 no-print">{isStarred ? '★' : '☆'}</button>
                          </div>
                          <div className="flex-1 mt-3 relative z-10 ml-4 overflow-hidden">
                            <div className="text-lg md:text-xl font-black tracking-tight text-main cursor-pointer hover:underline underline-offset-2 whitespace-normal break-words" onClick={() => { setSearchQuery(evt.artiste); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                              {renderFormattedArtiste(evt.artiste)}
                            </div>
                            <div className="text-[10px] md:text-xs font-bold italic opacity-60 uppercase text-sub truncate mt-1">{evt.classTitle}</div>
                          </div>
                          <div className="flex justify-between items-center mt-4 pt-4 border-t border-black/5 relative z-10 ml-4">
                            <div className="flex gap-1.5 items-center flex-wrap">
                              <span onClick={() => { setSelectedCategory(evt.category); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="bg-slate-50 border border-slate-200 text-[7px] md:text-[9px] font-black px-2 py-0.5 rounded uppercase text-sub cursor-pointer hover:bg-slate-200">{evt.category}</span>
                              {evt.isOn1Friendly && <span onClick={() => { setOn1Only(!on1Only); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="text-[9px] font-black text-blue-600 uppercase tracking-widest cursor-pointer hover:underline">On1 ⭐</span>}
                              {isAdmin && <div className="flex gap-2 no-print"><button onClick={() => startEditing(evt)} className="text-[8px] font-black text-blue-600 uppercase bg-blue-50 px-2 py-0.5 rounded">Edit</button><button onClick={() => handleDeleteEvent(evt.id)} className="text-[8px] font-black text-red-600 uppercase bg-red-50 px-2 py-0.5 rounded">Del</button></div>}
                            </div>
                            <button onClick={() => { setSelectedEvent(evt); setShowMapMode(false); }} className="bg-slate-50 text-slate-900 text-[9px] px-3 py-1 rounded-full font-black uppercase border border-slate-200 shadow-sm active:scale-95 transition-transform no-print">Info</button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* CLASS INFO MODAL */}
      {selectedEvent && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-md z-[100] flex items-center justify-center p-4 no-print" onClick={() => setSelectedEvent(null)}>
          <div className="w-full max-w-lg bg-white rounded-[40px] shadow-[0_20px_50px_rgba(0,0,0,0.3)] p-10 relative border-l-[16px] overflow-y-auto max-h-[90vh]" style={{ borderLeftColor: COLOR_MAP[EVENT_COLORS[selectedEvent.category]] }} onClick={e => e.stopPropagation()}>
            <button onClick={() => setSelectedEvent(null)} className="sticky top-0 float-right w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center text-xl font-bold hover:bg-slate-200 transition-colors z-10">✕</button>
            {showMapMode ? (
              <div>
                <div className="mb-4 flex justify-between items-end border-b pb-4">
                  <div>
                    <h3 className="text-xs font-black uppercase text-slate-400 tracking-widest">Floor Plan</h3>
                    <h2 className="text-2xl font-black text-slate-900 uppercase italic leading-none">{selectedEvent.room}</h2>
                  </div>
                  <button onClick={() => setShowMapMode(false)} className="bg-slate-900 text-white px-4 py-2 rounded-full text-[10px] font-black uppercase shadow-sm active:scale-95 transition-transform">Back to Info</button>
                </div>
                <div className="relative bg-slate-100 rounded-3xl overflow-hidden border border-slate-200" style={{ height: '350px' }}>
                  <img src={ROOM_MAP_DATA[selectedEvent.room]?.img || MAP_GROUND} className="w-full h-full object-contain" alt="Map" />
                  {ROOM_MAP_DATA[selectedEvent.room] && <div className="map-pin" style={{ left: ROOM_MAP_DATA[selectedEvent.room].x, top: ROOM_MAP_DATA[selectedEvent.room].y }}></div>}
                </div>
                <p className="mt-4 text-center text-[10px] font-black text-slate-400 uppercase tracking-widest">Located on the {ROOM_MAP_DATA[selectedEvent.room]?.floor || 'Ground'} Floor</p>
              </div>
            ) : (
              <div>
                {!selectedEvent.artiste.includes(',') && PHOTO_MAP[selectedEvent.artiste] && <img src={PHOTO_MAP[selectedEvent.artiste]} alt={selectedEvent.artiste} className="w-full rounded-2xl mb-6" />}
                <div className="mb-6 flex justify-between items-start">
                  <span className="text-xs font-black uppercase tracking-[0.2em] text-slate-400">{selectedEvent.startTime} — {selectedEvent.endTime}</span>
                  <button onClick={() => setShowMapMode(true)} className="bg-amber-400 text-amber-950 px-5 py-2.5 rounded-full text-[10px] font-black uppercase shadow-lg active:scale-95 transition-all">📍 Locate Room</button>
                </div>
                <h2 className="text-4xl font-black text-slate-900 mb-2 leading-none uppercase italic tracking-tighter">{renderFormattedArtiste(selectedEvent.artiste)} {selectedEvent.isOn1Friendly && '⭐'}</h2>
                <p className="text-xl font-bold italic text-slate-500 mb-8 uppercase tracking-tight">{selectedEvent.classTitle}</p>
                <div className="h-px bg-slate-100 w-full mb-8"></div>
                <div className="text-base leading-relaxed text-slate-700 font-semibold whitespace-pre-wrap">{selectedEvent.longDescription || "Description coming soon."}</div>
                {isGlobalRatingEnabled && (
                  <div className="mt-8 pt-6 border-t border-slate-100">
                    <h3 className="text-center text-[10px] font-black uppercase text-slate-400 tracking-widest mb-4">{userRatings[selectedEvent.id] ? "Your Feedback" : "Rate this Class"}</h3>
                    <div className="flex justify-center gap-3">
                      {[1,2,3,4,5].map(star => {
                        const currentRating = userRatings[selectedEvent.id];
                        const isFilled = currentRating >= star;
                        return (
                          <button key={star} onClick={() => handleRateClass(selectedEvent.id, selectedEvent.artiste, star)} disabled={!!currentRating} className={`text-4xl transition-all duration-300 ${isFilled ? 'text-amber-400 scale-110 drop-shadow-md' : 'text-slate-200 hover:text-amber-200 hover:scale-110'} ${!!currentRating && 'cursor-default'}`}>★</button>
                        );
                      })}
                    </div>
                    {userRatings[selectedEvent.id] && <p className="text-center text-[10px] font-bold text-amber-500 uppercase tracking-widest mt-4">Thank you for your feedback!</p>}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {shareToast && <div className="share-toast">✓ Link copied — mc5star.web.app</div>}
      <footer className="text-center p-12 opacity-30 text-[9px] font-bold uppercase tracking-[0.5em] border-t mt-16 no-print">5Star Congress 2026 • Sync: {lastUpdated}</footer>
      {showJumpTop && <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="fixed bottom-6 right-6 z-[60] bg-slate-900 text-white w-12 h-12 rounded-full shadow-2xl flex items-center justify-center text-xl border border-white/20 active:scale-90 transition-transform no-print">↑</button>}
    </div>
  );
}

export default App;